import moment, { Moment } from 'moment';

export const getDate = (date?: string | Moment) => {
	if (date) {
		return moment(date);
	}
	return moment();
};

export const getDateAsIso = (date?: string | Moment) => {
	if (date) {
		return moment(date).toISOString();
	}
	return moment().toISOString();
};

export const convertFromMilliseconds = (
	milliseconds: number,
): { hours: string; minutes: string; seconds: string } => {
	const pad = (number: number, size = 2) => {
		let numb = number.toString();
		while (numb.length < size) numb = '0' + numb;
		return numb;
	};

	const totalSeconds = Math.floor(milliseconds / 1000);
	const hours = Math.floor(totalSeconds / 3600);
	const remainingSecondsAfterHours = totalSeconds % 3600;
	const minutes = Math.floor(remainingSecondsAfterHours / 60);
	const seconds = remainingSecondsAfterHours % 60;

	return {
		hours: pad(hours),
		minutes: pad(minutes),
		seconds: pad(seconds),
	};
};

export const getFormatedDate = ({
	date,
	format,
	includeTime,
}: {
	date: string;
	format: string;
	includeTime?: boolean;
}) => {
	if (includeTime) {
		format += ', HH:mm';
	}
	return moment(date).format(format);
};
